import { Flex, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import TeamMemberForm from './TeamMemberForm';
import { Heading } from '@/components/Heading';
import { Role, TeamMember } from '@/types';

interface Props {
  teamMemberUID?: string;
  teamMemberData?: TeamMember;
  onClose: () => void;
  roleList?: Role[];
}
const TeamMemberModal = ({ teamMemberData, teamMemberUID, onClose, roleList }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      className='rounded-[20px] bg-white border   border-customGrayShade3'
      title={
        <Flex style={{ borderBottom: '1px solid #E1E1E3', paddingBottom: '1rem' }}>
          <Heading
            title={teamMemberUID ? t('update_user') : t('add_new_user')}
            upperCase
            fontSize='text-lg'
            fontWeight='font-semibold'
          />
        </Flex>
      }
      width={760}
      centered
      footer={null}
      open={teamMemberUID !== undefined}
      onOk={onClose}
      onCancel={onClose}
      destroyOnClose
    >
      <TeamMemberForm
        onClose={onClose}
        teamMemberData={teamMemberData}
        teamMemberUID={teamMemberUID}
        roleList={roleList}
      />
    </Modal>
  );
};

export default TeamMemberModal;
